export function AppDown({}) {
    return (
        <div>
            Sorry, the app is down. Please try again later.
        </div>
    )
}